import React from 'react';
const points = [{
  num: '01',
  title: 'Passi ore a preparare',
  desc: 'Sacrifichi il tuo tempo libero per cercare materiale, immagini e schemi per la prossima lezione.'
}, {
  num: '02',
  title: 'Le lezioni sembrano sempre uguali',
  desc: 'Senti che ti manca materiale visivo e pratico per rendere la biologia affascinante.'
}, {
  num: '03',
  title: 'Gli studenti perdono interesse',
  desc: 'Hai bisogno di nuovi stimoli, laboratori e attività per coinvolgere anche le classi più difficili.'
}, {
  num: '04',
  title: 'Ti manca un sistema organizzato',
  desc: 'Hai tanto materiale sparso ma nessun percorso strutturato dalla prima media alla quinta superiore.'
}, {
  num: '05',
  title: 'Hai poco tempo',
  desc: 'Tra burocrazia e consigli di classe, il tempo per creare verifiche e mappe da zero è inesistente.'
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 relative overflow-hidden" data-id="element-150">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/10 rounded-full blur-[100px] pointer-events-none" data-id="element-151"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-152">
        <div className="text-center mb-12" data-id="element-153">
          <h2 className="text-3xl sm:text-5xl font-montserrat font-black text-text-main mb-4 tracking-tight" data-id="element-154">
            👀 Ti riconosci in queste situazioni?
          </h2>
        </div>

        <div className="space-y-4" data-id="element-155">
          {points.map((point, i) => <div key={i} className="flex items-start gap-5 bg-bg-alt/80 backdrop-blur-sm rounded-2xl p-6 border border-border-light hover:border-primary/50 transition-colors group shadow-md" data-id="element-156">
              <span className="text-primary font-montserrat font-black text-2xl sm:text-3xl flex-shrink-0 leading-none mt-0.5" data-id="element-157">
                {point.num}
              </span>
              <div data-id="element-158">
                <h3 className="text-text-main text-lg sm:text-xl font-bold mb-1.5" data-id="element-159">
                  {point.title}
                </h3>
                <p className="text-text-sec text-base font-medium leading-relaxed" data-id="element-160">
                  {point.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="text-center mt-10" data-id="element-161">
          <p className="text-text-main font-bold text-lg sm:text-xl mb-6" data-id="element-162">
            ✋ Se ti sei riconosciuto…{' '}
            <span className="text-primary" data-id="element-163">
              allora BIOLOGIA PRONTA™ è il Kit che stavi cercando.
            </span>
          </p>
        </div>
      </div>
    </section>;
}